const $ = jQuery;

const cSPrefillCalculatorResults = (campaignID) => {
	// Get campaign with id
	$.post(
		CSWP.ajax_url,
		{
			_ajax_nonce: CSWP.nonce,
			action: "cs_handle_calculator_getcampaignbyid",
			campaign_id: campaignID,
		},
		(data) => {
			try {
				data = JSON.parse(data);
				const campaign = data;
				if (campaignID !== data._id) {
					// No data was found or data does not match id so we do not preload any data
					return;
				}

				if (data.type === "posting") {
					cSPrefillCalculatorResultsPosting(data);
					cSCalculateAndRenderPosting(data);
				}

				if (data.type === "content") {
					cSPrefillCalculatorResultsContent(data);
					cSCalculateAndRenderContent(data);
				}

				$(".ajax-loading").hide().remove();
			} catch (error) {
				console.log(error);
				return;
			}
		}
	);
};

export default cSPrefillCalculatorResults;
